import * as React from "react";
import { Fab, Tooltip, keyframes } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import { useRc } from "./RcContext";

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(198, 40, 40, 0.45); }
  70% { box-shadow: 0 0 0 14px rgba(198, 40, 40, 0); }
  100% { box-shadow: 0 0 0 0 rgba(198, 40, 40, 0); }
`;

const RcFab: React.FC = () => {
  const { listening, thinking, toggleListen, open, setOpen } = useRc();

  return (
    <Tooltip
      title={
        listening
          ? "RC is listening — click to stop"
          : "Talk to RC (Ctrl/Cmd+Shift+Space). Mic stays on until you click again. Right-click opens panel only."
      }
      placement="left"
    >
      <Fab
        color="primary"
        aria-label="RC voice assistant"
        onClick={() => {
          if (!open) {
            setOpen(true);
            if (!listening) toggleListen();
            return;
          }
          toggleListen();
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          setOpen(!open);
        }}
        disabled={thinking && !listening}
        sx={{
          position: "fixed",
          right: 24,
          bottom: 24,
          zIndex: (theme) => theme.zIndex.modal + 1,
          bgcolor: listening ? "#c62828" : "#1565c0",
          "&:hover": {
            bgcolor: listening ? "#b71c1c" : "#0d47a1",
          },
          animation: listening ? `${pulse} 1.4s ease-out infinite` : "none",
        }}
      >
        {listening ? <MicOffIcon /> : <MicIcon />}
      </Fab>
    </Tooltip>
  );
};

export default RcFab;
